import { Grid, Typography, Box, makeStyles, } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import CountyContext from '../../contexts/CountyContext';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';
import CountyComparisonTableHome from './CountyComparisonTableHome';
import CountyMapHome from './CountyMapHome';
import ErrorBoundary from '../ErrorBoundary';

function Q1Row1() {
  const [county, setCounty] = useState(null);
  const [countyCode, setCountyCode] = useState(null);
  const [countyData, setCountyData] = useState(null);

  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    }
  }))();

  return (
    <CountyContext.Provider value={{
      county, setCounty, countyCode, setCountyCode, countyData, setCountyData,
    }}
    >
      <SubquestionBox color={lightColor}>
        <Grid
          container
          spacing={2}
          direction="row"
          justify="center"
          alignItems="center"
        >
          {/* <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item xs={10} sm={10}>
                <MessageBox>
                  <Typography variant="body1">
                    The only way to know if a child has been exposed to lead is to have the child&apos;s blood tested. There is no safe blood lead level in children. Even low levels can affect IQ, the ability to pay attention and academic achievement.
                    <br /><br />
                    In areas with a high percentage of older homes and a low percentage of children under 6 being tested, elevated blood levels in children may go undetected.
                  </Typography>
                </MessageBox>
              </Grid>
            </Grid>
          </Grid> */}
          <Grid item xs={12}>
            <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
              Percent Of Old Homes By County
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            {/* <Box displayPrint="none">
              <Typography variant="h6" align="center" style={{ textTransform: 'capitalize' }}>
                Click on a county to see that county&apos;s housing data
              </Typography>
            </Box> */}
            <ErrorBoundary>
              <CountyMapHome />
            </ErrorBoundary>
          </Grid>
        </Grid>
        <div className="pagebreak100" />
        <Grid
          spacing={2}
          container
          direction="row"
          justify="center"
          alignItems="flex-start"
        >
          <Grid item xs={12}>
            <ErrorBoundary>
              <CountyComparisonTableHome />
            </ErrorBoundary>
          </Grid>
        </Grid>
      </SubquestionBox>
    </CountyContext.Provider>
  );
}

export default Q1Row1;
